'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Headline;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Headline(_ref) {
  var moduleClass = _ref.moduleClass,
      content = _ref.content;

  return _react2.default.createElement('div', {
    className: 'type-headline ' + moduleClass,
    dangerouslySetInnerHTML: {
      __html: content
    }
  });
} /*
     {
       "type": "headline",
       "content": "..."
     }
  
     This is for specifically larger, bolder, headline text, as seen as the first page
     element on most of the comps (like Educator and Employer).
  
     This does not accept a title attribute.
  */
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Headline/Headline.jsx
// module id = 1160
// module chunks = 0